import React from 'react';
import { buildMockTenantDomain, makeDate } from './data.jsx';
import { normStatus } from './lojas.jsx';
// Dados mock — Tenant Cockpit (Super Admin Tezus)

const md = (subdomain) => (
  typeof buildMockTenantDomain === 'function' ? buildMockTenantDomain(subdomain) : `${subdomain}.localhost`
);

const COCKPIT_TENANT = {
  id: 42,
  tenantId: 'stor_0042',
  schemaName: 'loja_exemplo_premium',
  name: 'Loja Exemplo Premium',
  plan: { id: 'pro', name: 'Pro', price: 499 },
  status: 'active',
  domain: md('loja-exemplo'),
  customDomain: 'www.lojaexemplo.com.br',
  ownerName: 'Ana Pereira',
  ownerEmail: 'ana@lojaexemplo.com.br',
  ownerPhone: '(11) 99201-4242',
  staffCount: 6,
  createdAt: makeDate(187),
  lastAccess: makeDate(0),
  healthScore: 86,
  billingStatus: 'active',
  storageUsed: 2.4,
  storageLimit: 10,
  searchLastIndexed: makeDate(3),
  color: '#1B3D60',
};

const COCKPIT_HEALTH_CHECKS = [
  { id: 'tenant-public',   name: 'Tenant no schema público',      desc: 'Registro do tenant existe no schema público do banco',      status: 'ok',      lastCheck: 'Há 5 min', category: 'infra',    repairAction: null },
  { id: 'schema-created',  name: 'Schema do tenant criado',        desc: 'Schema isolado foi criado e está acessível',               status: 'ok',      lastCheck: 'Há 5 min', category: 'infra',    repairAction: null },
  { id: 'tenant-mapping',  name: 'TenantMapping existente',        desc: 'Mapeamento tenant_id → schema verificado',                 status: 'ok',      lastCheck: 'Há 5 min', category: 'infra',    repairAction: null },
  { id: 'storage-r2',      name: 'Storage/R2 configurado',         desc: 'Bucket R2 do tenant existe e está acessível',              status: 'ok',      lastCheck: 'Há 5 min', category: 'infra',    repairAction: null },
  { id: 'cache-active',    name: 'Cache ativo',                    desc: 'Cache do tenant operando normalmente',                     status: 'ok',      lastCheck: 'Há 5 min', category: 'infra',    repairAction: null },
  { id: 'search-index',    name: 'Busca / indexação ativa',        desc: 'Índice de busca desatualizado há 3 dias',                  status: 'warning', lastCheck: 'Há 2h',    category: 'infra',    repairAction: 'reindex' },
  { id: 'primary-domain',  name: 'Domínio primário configurado',   desc: 'Subdomínio primário do ambiente aponta corretamente',     status: 'ok',      lastCheck: 'Há 5 min', category: 'domain',   repairAction: null },
  { id: 'custom-domain',   name: 'Domínio customizado',            desc: 'DNS do domínio personalizado ainda não verificado',        status: 'warning', lastCheck: 'Há 1h',    category: 'domain',   repairAction: 'validate-dns' },
  { id: 'site-config',     name: 'Site configurado',               desc: 'Objeto Site com domain e name corretos',                  status: 'ok',      lastCheck: 'Há 5 min', category: 'store',    repairAction: null },
  { id: 'store-settings',  name: 'StoreSettings existente',        desc: 'Configurações da loja inicializadas',                     status: 'ok',      lastCheck: 'Há 5 min', category: 'store',    repairAction: null },
  { id: 'dist-center',     name: 'Centro de distribuição',         desc: 'Pelo menos um CD ativo configurado',                      status: 'ok',      lastCheck: 'Há 5 min', category: 'store',    repairAction: null },
  { id: 'partner',         name: 'Partner criado',                 desc: 'Objeto Partner vinculado ao tenant',                      status: 'ok',      lastCheck: 'Há 5 min', category: 'store',    repairAction: null },
  { id: 'partner-address', name: 'PartnerAddress criado',          desc: 'Endereço do Partner configurado',                         status: 'ok',      lastCheck: 'Há 5 min', category: 'store',    repairAction: null },
  { id: 'active-theme',    name: 'Tema ativo',                     desc: 'Tenant possui tema aplicado e publicado',                  status: 'ok',      lastCheck: 'Há 5 min', category: 'store',    repairAction: null },
  { id: 'manager-role',    name: 'Role "Gerente" criada',          desc: 'Permissões de gerente configuradas no tenant',             status: 'ok',      lastCheck: 'Há 5 min', category: 'access',   repairAction: null },
  { id: 'owner-linked',    name: 'Owner / admin vinculado',        desc: 'Usuário admin vinculado ao tenant',                       status: 'ok',      lastCheck: 'Há 5 min', category: 'access',   repairAction: null },
  { id: 'staff-profile',   name: 'StaffUserProfile criado',        desc: 'Perfil de staff do owner inicializado',                   status: 'ok',      lastCheck: 'Há 5 min', category: 'access',   repairAction: null },
  { id: 'prod-classes',    name: 'Product Classes criadas',        desc: 'Pelo menos uma classe de produto disponível',             status: 'ok',      lastCheck: 'Há 5 min', category: 'catalog',  repairAction: null },
  { id: 'prod-attributes', name: 'Product Attributes criados',    desc: 'Atributos de produto configurados',                       status: 'ok',      lastCheck: 'Há 5 min', category: 'catalog',  repairAction: null },
  { id: 'public-tokens',   name: 'Tokens públicos válidos',        desc: 'Token de API sem rotação há 97 dias (limite: 90d)',        status: 'error',   lastCheck: 'Há 3h',    category: 'security', repairAction: 'rotate-tokens' },
];

const PROVISIONING_STEPS = [
  { id: 1,  name: 'Usuário admin criado',              status: 'done', ts: '02/11/2025 14:22:01', duration: '320ms', msg: 'User ID: usr_4892 criado no schema público' },
  { id: 2,  name: 'Tenant criado',                     status: 'done', ts: '02/11/2025 14:22:02', duration: '180ms', msg: 'Tenant ID: 42, schema: loja_exemplo_premium' },
  { id: 3,  name: 'Domínio criado',                    status: 'done', ts: '02/11/2025 14:22:03', duration: '95ms',  msg: `domain: ${md('loja-exemplo')}` },
  { id: 4,  name: 'TenantMapping criado',               status: 'done', ts: '02/11/2025 14:22:04', duration: '110ms', msg: 'Mapping tenant_id=42 → loja_exemplo_premium' },
  { id: 5,  name: 'Temas liberados',                   status: 'done', ts: '02/11/2025 14:22:05', duration: '230ms', msg: '3 temas do plano Pro liberados para o tenant' },
  { id: 6,  name: 'Schema inicializado (bootstrap)',   status: 'done', ts: '02/11/2025 14:22:07', duration: '1.8s',  msg: 'migrate --schema=loja_exemplo_premium: 142 migrações aplicadas' },
  { id: 7,  name: 'Site configurado',                  status: 'done', ts: '02/11/2025 14:22:09', duration: '145ms', msg: `Site: Loja Exemplo Premium, domain: ${md('loja-exemplo')}` },
  { id: 8,  name: 'StoreSettings criado',              status: 'done', ts: '02/11/2025 14:22:10', duration: '88ms',  msg: 'StoreSettings inicializado com defaults do plano Pro' },
  { id: 9,  name: 'Centro de distribuição criado',     status: 'done', ts: '02/11/2025 14:22:10', duration: '112ms', msg: 'Partner: Loja Exemplo Premium LTDA, ID: 38' },
  { id: 10, name: 'Product classes criadas',           status: 'done', ts: '02/11/2025 14:22:11', duration: '215ms', msg: '5 classes de produto padrão criadas' },
  { id: 11, name: 'Product attributes criados',        status: 'done', ts: '02/11/2025 14:22:12', duration: '192ms', msg: '18 atributos de produto criados' },
  { id: 12, name: 'Role gerente criada',               status: 'done', ts: '02/11/2025 14:22:12', duration: '67ms',  msg: 'Role "Gerente" com 47 permissões configuradas' },
  { id: 13, name: 'Staff profile criado',              status: 'done', ts: '02/11/2025 14:22:13', duration: '154ms', msg: 'StaffUserProfile para ana@lojaexemplo.com.br' },
  { id: 14, name: 'Provisionamento concluído',         status: 'done', ts: '02/11/2025 14:22:13', duration: '—',     msg: 'Token JWT gerado e retornado ao owner. Total: 4.5s' },
];

const COCKPIT_STAFF_USERS = [
  { name: 'Ana Rodrigues',  email: 'ana@lojaexemplo.com.br',      role: 'Owner',      isOwner: true,  status: 'ativo',   lastAccess: 'Há 2 horas',  mfa: true  },
  { name: 'Carlos Lima',    email: 'carlos@lojaexemplo.com.br',   role: 'Gerente',    isOwner: false, status: 'ativo',   lastAccess: 'Ontem 15:44', mfa: true  },
  { name: 'Júlia Fonseca',  email: 'julia@lojaexemplo.com.br',    role: 'Estoque',    isOwner: false, status: 'ativo',   lastAccess: 'Há 3 dias',   mfa: false },
  { name: 'Marcos Pereira', email: 'marcos@lojaexemplo.com.br',   role: 'Financeiro', isOwner: false, status: 'ativo',   lastAccess: 'Há 5 dias',   mfa: false },
  { name: 'Fernanda Silva', email: 'fernanda@lojaexemplo.com.br', role: 'Vendas',     isOwner: false, status: 'ativo',   lastAccess: 'Há 8 dias',   mfa: false },
  { name: 'Pedro Alves',    email: 'pedro@lojaexemplo.com.br',    role: 'Suporte',    isOwner: false, status: 'inativo', lastAccess: 'Há 45 dias',  mfa: false },
];

const COCKPIT_ROLES = [
  { name: 'Owner',      permissions: 142, users: 1, syncStatus: 'ok' },
  { name: 'Gerente',    permissions: 47,  users: 1, syncStatus: 'ok' },
  { name: 'Estoque',    permissions: 18,  users: 1, syncStatus: 'ok' },
  { name: 'Financeiro', permissions: 24,  users: 1, syncStatus: 'ok' },
  { name: 'Vendas',     permissions: 12,  users: 1, syncStatus: 'ok' },
];

const COCKPIT_DOMAINS = {
  primary: { url: md('loja-exemplo'), ssl: true, siteId: 1, siteName: 'Loja Exemplo Premium' },
  custom:  { url: 'www.lojaexemplo.com.br', ssl: true, dnsVerified: false, dnsStatus: 'Propagando (TTL 3600)' },
  activeTheme: 'Vitrini Clean',
  themeVersion: '2.4.1',
  availableThemes: ['Vitrini Clean', 'Mercado Dark', 'Boutique Elegance'],
};

const COCKPIT_AUDIT_LOG = [
  { ts: 'Hoje, 14:22',   actor: 'Julio Lazzaron', orgRole: 'Super Admin', action: 'Login como lojista iniciado',   resource: 'Sessão',     result: 'success', ip: '200.1.10.44',   severity: 'info',    motivo: 'Suporte ao cliente #1042' },
  { ts: 'Hoje, 11:08',   actor: 'Pedro Chaves',   orgRole: 'Admin',       action: 'Diagnóstico completo rodado',   resource: 'Sistema',    result: 'success', ip: '200.1.10.45',   severity: 'info',    motivo: 'Manutenção preventiva' },
  { ts: 'Ontem, 18:30',  actor: 'Sistema',        orgRole: '—',           action: 'Token revogado automaticamente', resource: 'Token',     result: 'success', ip: '—',             severity: 'warning', motivo: 'Rotação automática 90d' },
  { ts: 'Ontem, 14:55',  actor: 'Beatriz Lima',   orgRole: 'Suporte',     action: 'Plano alterado: Basic → Pro', resource: 'Assinatura', result: 'success', ip: '200.1.10.46',   severity: 'info',    motivo: 'Solicitação da lojista' },
  { ts: '15 Abr, 09:20', actor: 'Rafael Tavares', orgRole: 'Suporte',     action: 'Repair: Reindexação busca',    resource: 'Busca',      result: 'success', ip: '200.1.10.47',   severity: 'info',    motivo: 'Busca desatualizada' },
  { ts: '12 Abr, 16:10', actor: 'Ana Rodrigues',  orgRole: 'Owner',       action: 'Senha alterada',               resource: 'Usuário',    result: 'success', ip: '179.215.88.12', severity: 'info',    motivo: '—' },
  { ts: '05 Abr, 11:00', actor: 'Sistema',        orgRole: '—',           action: 'Domínio validado',             resource: 'DNS',        result: 'success', ip: '—',             severity: 'info',    motivo: 'Propagação DNS concluída' },
  { ts: '02 Nov, 14:22', actor: 'Sistema',        orgRole: '—',           action: 'Tenant criado',                resource: 'Tenant',     result: 'success', ip: '—',             severity: 'info',    motivo: 'Provisionamento inicial' },
];

const COCKPIT_ALERTS = [
  { id: 'token',  severity: 'danger',  title: 'Token público sem rotação há 97 dias',    desc: 'Recomendado rotacionar a cada 90 dias por segurança.',   action: 'Revogar tokens', tab: 'health'  },
  { id: 'dns',    severity: 'warning', title: 'Domínio customizado sem verificação DNS', desc: 'www.lojaexemplo.com.br aguarda propagação DNS.',         action: 'Validar DNS',    tab: 'domains' },
  { id: 'search', severity: 'warning', title: 'Índice de busca desatualizado há 3 dias', desc: 'Pode afetar a relevância dos resultados de busca.',      action: 'Reindexar',      tab: 'health'  },
];

// ── Per-tenant cockpit mocks ──────────────────────────────────────────────────
// Cada entrada sobrepõe os dados padrão para aquele store.
const COCKPIT_OVERRIDES = {

  // ── Loja Exemplo Premium — saudável ───────────────────────────────────────
  'stor_0042': {
    staffCount: 6, storageUsed: 2.4, storageLimit: 10, healthScore: 86,
    billingStatus: 'active',
    healthChecks: COCKPIT_HEALTH_CHECKS,
    alerts: COCKPIT_ALERTS,
    provisioningSteps: PROVISIONING_STEPS,
    staffUsers: COCKPIT_STAFF_USERS,
    roles: COCKPIT_ROLES,
    domains: COCKPIT_DOMAINS,
    auditLog: COCKPIT_AUDIT_LOG,
  },

  // ── Tech Store Brasil — inadimplente ──────────────────────────────────────
  'stor_0077': {
    staffCount: 3, storageUsed: 0.8, storageLimit: 10, healthScore: 72,
    billingStatus: 'past_due',
    healthChecks: [
      ...COCKPIT_HEALTH_CHECKS.filter(c => c.id !== 'search-index' && c.id !== 'custom-domain' && c.id !== 'public-tokens'),
      { id: 'search-index', name: 'Busca / indexação ativa', desc: 'Índice atualizado normalmente', status: 'ok', lastCheck: 'Há 5 min', category: 'infra', repairAction: null },
      { id: 'custom-domain', name: 'Domínio customizado', desc: 'Sem domínio personalizado configurado', status: 'ok', lastCheck: 'Há 5 min', category: 'domain', repairAction: null },
      { id: 'billing-status', name: 'Status de pagamento', desc: 'Fatura vencida há 12 dias — tenant em inadimplência', status: 'error', lastCheck: 'Há 2 min', category: 'store', repairAction: null },
      { id: 'public-tokens', name: 'Tokens públicos válidos', desc: 'Token ativo sem problemas relatados', status: 'ok', lastCheck: 'Há 5 min', category: 'security', repairAction: null },
    ],
    alerts: [
      { id: 'billing', severity: 'danger', title: 'Fatura vencida há 12 dias', desc: 'INV-2026-0091 · R$ 199,00 · 2 tentativas de cobrança falharam.', action: 'Ver billing', tab: 'actions' },
    ],
    provisioningSteps: PROVISIONING_STEPS.map(s => ({
      ...s,
      ts: s.ts.replace('02/11/2025', '15/08/2025'),
      msg: s.msg.replace('loja_exemplo_premium', 'tech_store_brasil').replace('Loja Exemplo Premium', 'Tech Store Brasil').replace('ana@lojaexemplo.com.br', 'carlos@techstore.com.br'),
    })),
    staffUsers: [
      { name: 'Carlos Mendes', email: 'carlos@techstore.com.br', role: 'Owner', isOwner: true, status: 'ativo', lastAccess: 'Há 3 dias', mfa: false },
      { name: 'Paula Gomes',   email: 'paula@techstore.com.br',  role: 'Gerente', isOwner: false, status: 'ativo', lastAccess: 'Há 1 semana', mfa: false },
      { name: 'Diego Lima',    email: 'diego@techstore.com.br',  role: 'Estoque', isOwner: false, status: 'inativo', lastAccess: 'Há 20 dias', mfa: false },
    ],
    roles: [
      { name: 'Owner',   permissions: 142, users: 1, syncStatus: 'ok' },
      { name: 'Gerente', permissions: 47,  users: 1, syncStatus: 'ok' },
      { name: 'Estoque', permissions: 18,  users: 1, syncStatus: 'ok' },
    ],
    domains: {
      primary: { url: md('techstore'), ssl: true, siteId: 2, siteName: 'Tech Store Brasil' },
      custom: null,
      activeTheme: 'Mercado Dark', themeVersion: '1.2.0',
      availableThemes: ['Mercado Dark', 'Vitrini Clean'],
    },
    auditLog: [
      { ts: 'Hoje, 09:22',  actor: 'Billing System', orgRole: '—',      action: 'Cobrança falhou — 2ª tentativa', resource: 'Fatura', result: 'error',   ip: '—',            severity: 'warning', motivo: 'Cartão recusado' },
      { ts: 'Há 12 dias',   actor: 'Billing System', orgRole: '—',      action: 'Fatura vencida — marcado inadimplente', resource: 'Assinatura', result: 'success', ip: '—', severity: 'warning', motivo: 'Automático D+7' },
      { ts: '15 Ago, 2025', actor: 'Sistema',        orgRole: '—',      action: 'Tenant criado', resource: 'Tenant', result: 'success', ip: '—', severity: 'info', motivo: 'Provisionamento inicial' },
    ],
  },

  // ── Moda Clara — falha de provisionamento ────────────────────────────────
  'stor_0103': {
    staffCount: 0, storageUsed: 0, storageLimit: 10, healthScore: 41,
    billingStatus: 'trialing',
    healthChecks: [
      { id: 'tenant-public',  name: 'Tenant no schema público',    desc: 'Registro do tenant criado',                   status: 'ok',    lastCheck: 'Há 5 min', category: 'infra',    repairAction: null },
      { id: 'schema-created', name: 'Schema do tenant criado',     desc: 'Schema isolado criado e acessível',           status: 'ok',    lastCheck: 'Há 5 min', category: 'infra',    repairAction: null },
      { id: 'tenant-mapping', name: 'TenantMapping existente',     desc: 'Mapeamento tenant_id → schema verificado',    status: 'ok',    lastCheck: 'Há 5 min', category: 'infra',    repairAction: 'recreate-mapping' },
      { id: 'storage-r2',     name: 'Storage/R2 configurado',      desc: 'Bucket R2 não criado — provisionamento falhou', status: 'error', lastCheck: 'Há 5 min', category: 'infra',    repairAction: null },
      { id: 'cache-active',   name: 'Cache ativo',                 desc: 'Cache não inicializado para este tenant',      status: 'error', lastCheck: 'Há 5 min', category: 'infra',    repairAction: null },
      { id: 'search-index',   name: 'Busca / indexação ativa',     desc: 'Índice não criado — provisionamento incompleto', status: 'error', lastCheck: 'Há 5 min', category: 'infra',    repairAction: null },
      { id: 'primary-domain', name: 'Domínio primário configurado','desc': 'Subdomínio primário do ambiente configurado', status: 'ok',    lastCheck: 'Há 5 min', category: 'domain',   repairAction: null },
      { id: 'custom-domain',  name: 'Domínio customizado',         desc: 'Sem domínio personalizado',                   status: 'ok',    lastCheck: 'Há 5 min', category: 'domain',   repairAction: null },
      { id: 'site-config',    name: 'Site configurado',            desc: 'Site criado mas sem StoreSettings',           status: 'warning', lastCheck: 'Há 5 min', category: 'store',    repairAction: null },
      { id: 'store-settings', name: 'StoreSettings existente',     desc: 'StoreSettings NÃO criado — falhou no step 8', status: 'error', lastCheck: 'Há 5 min', category: 'store',    repairAction: 'recreate-store-settings' },
      { id: 'dist-center',    name: 'Centro de distribuição',      desc: 'CD não criado — aguarda provisionamento',     status: 'error', lastCheck: 'Há 5 min', category: 'store',    repairAction: null },
      { id: 'partner',        name: 'Partner criado',              desc: 'Partner não criado',                          status: 'error', lastCheck: 'Há 5 min', category: 'store',    repairAction: null },
      { id: 'partner-address',name: 'PartnerAddress criado',       desc: 'PartnerAddress não criado',                   status: 'error', lastCheck: 'Há 5 min', category: 'store',    repairAction: null },
      { id: 'active-theme',   name: 'Tema ativo',                  desc: 'Nenhum tema aplicado',                        status: 'error', lastCheck: 'Há 5 min', category: 'store',    repairAction: null },
      { id: 'manager-role',   name: 'Role "Gerente" criada',       desc: 'Role não criada — provisionamento incompleto', status: 'error', lastCheck: 'Há 5 min', category: 'access',   repairAction: 'recreate-manager-role' },
      { id: 'owner-linked',   name: 'Owner / admin vinculado',     desc: 'Owner criado mas sem perfil de staff',        status: 'warning', lastCheck: 'Há 5 min', category: 'access',   repairAction: null },
      { id: 'staff-profile',  name: 'StaffUserProfile criado',     desc: 'StaffUserProfile não criado',                 status: 'error', lastCheck: 'Há 5 min', category: 'access',   repairAction: null },
      { id: 'prod-classes',   name: 'Product Classes criadas',     desc: 'Não criadas — aguarda provisionamento',       status: 'error', lastCheck: 'Há 5 min', category: 'catalog',  repairAction: null },
      { id: 'prod-attributes',name: 'Product Attributes criados',  desc: 'Não criados — aguarda provisionamento',       status: 'error', lastCheck: 'Há 5 min', category: 'catalog',  repairAction: null },
      { id: 'public-tokens',  name: 'Tokens públicos válidos',     desc: 'Nenhum token gerado ainda',                   status: 'warning', lastCheck: 'Há 5 min', category: 'security', repairAction: null },
    ],
    alerts: [
      { id: 'prov-fail', severity: 'danger', title: 'Falha de provisionamento no step 8', desc: 'StoreSettings não criado após 2 tentativas. Intervenção manual necessária.', action: 'Re-provisionar', tab: 'provisioning' },
    ],
    provisioningSteps: [
      { id: 1,  name: 'Usuário admin criado',            status: 'done',   ts: '20/05/2026 10:00:01', duration: '290ms', msg: 'User ID: usr_5501 criado' },
      { id: 2,  name: 'Tenant criado',                   status: 'done',   ts: '20/05/2026 10:00:02', duration: '165ms', msg: 'Tenant ID: 103, schema: moda_clara' },
      { id: 3,  name: 'Domínio criado',                  status: 'done',   ts: '20/05/2026 10:00:03', duration: '88ms',  msg: `domain: ${md('moda-clara')}` },
      { id: 4,  name: 'TenantMapping criado',            status: 'done',   ts: '20/05/2026 10:00:04', duration: '102ms', msg: 'Mapping tenant_id=103 → moda_clara' },
      { id: 5,  name: 'Temas liberados',                 status: 'done',   ts: '20/05/2026 10:00:05', duration: '198ms', msg: '3 temas do plano Pro liberados' },
      { id: 6,  name: 'Schema inicializado (bootstrap)', status: 'done',   ts: '20/05/2026 10:00:07', duration: '2.1s',  msg: 'migrate --schema=moda_clara: 142 migrações aplicadas' },
      { id: 7,  name: 'Site configurado',                status: 'done',   ts: '20/05/2026 10:00:09', duration: '132ms', msg: `Site: Moda Clara, domain: ${md('moda-clara')}` },
      { id: 8,  name: 'StoreSettings criado',            status: 'error',  ts: '20/05/2026 10:00:10', duration: 'timeout', msg: 'ERRO: TimeoutError ao criar StoreSettings após 30s. Step abortado. Tentativa 2/2 também falhou.' },
      { id: 9,  name: 'Centro de distribuição criado',   status: 'skipped', ts: '—', duration: '—', msg: 'Pulado devido à falha no step 8' },
      { id: 10, name: 'Product classes criadas',         status: 'skipped', ts: '—', duration: '—', msg: 'Pulado devido à falha no step 8' },
      { id: 11, name: 'Product attributes criados',      status: 'skipped', ts: '—', duration: '—', msg: 'Pulado devido à falha no step 8' },
      { id: 12, name: 'Role gerente criada',             status: 'skipped', ts: '—', duration: '—', msg: 'Pulado devido à falha no step 8' },
      { id: 13, name: 'Staff profile criado',            status: 'skipped', ts: '—', duration: '—', msg: 'Pulado devido à falha no step 8' },
      { id: 14, name: 'Provisionamento concluído',       status: 'error',  ts: '—', duration: '—', msg: 'Provisionamento FALHOU na step 8. Intervenção manual necessária.' },
    ],
    staffUsers: [
      { name: 'Marina Costa', email: 'suporte@modaclara.com.br', role: 'Owner', isOwner: true, status: 'inativo', lastAccess: 'Nunca', mfa: false },
    ],
    roles: [],
    domains: {
      primary: { url: md('moda-clara'), ssl: true, siteId: 3, siteName: 'Moda Clara' },
      custom: null,
      activeTheme: null, themeVersion: null,
      availableThemes: [],
    },
    auditLog: [
      { ts: '20 Mai, 10:11', actor: 'provisioning_system', orgRole: '—', action: 'Provisionamento falhou — step 8', resource: 'StoreSettings', result: 'error', ip: '—', severity: 'danger', motivo: 'TimeoutError' },
      { ts: '20 Mai, 10:00', actor: 'Sistema',             orgRole: '—', action: 'Tenant criado — provisionamento iniciado', resource: 'Tenant', result: 'success', ip: '—', severity: 'info', motivo: 'Cadastro' },
    ],
  },

  // ── Agro Forte — trial ────────────────────────────────────────────────────
  'stor_0118': {
    staffCount: 2, storageUsed: 0.05, storageLimit: 10, healthScore: 91,
    billingStatus: 'trialing',
    healthChecks: COCKPIT_HEALTH_CHECKS.map(c => ({
      ...c,
      status: (c.id === 'search-index' || c.id === 'custom-domain' || c.id === 'public-tokens') ? 'ok' : c.status,
      desc: c.id === 'search-index'   ? 'Índice atualizado normalmente' :
            c.id === 'custom-domain'  ? 'Sem domínio personalizado configurado' :
            c.id === 'public-tokens'  ? 'Tokens gerados e válidos' :
            c.desc.replace('loja_exemplo_premium', 'agro_forte').replace('Loja Exemplo Premium', 'Agro Forte'),
      repairAction: null,
    })),
    alerts: [
      { id: 'trial', severity: 'warning', title: 'Trial expira em 5 dias (28/05/2026)', desc: 'Owner ainda não cadastrou método de pagamento.', action: 'Contatar owner', tab: 'actions' },
    ],
    provisioningSteps: PROVISIONING_STEPS.map(s => ({
      ...s,
      ts: s.ts.replace('02/11/2025', '18/05/2026'),
      msg: s.msg
        .replace('loja_exemplo_premium', 'agro_forte')
        .replace('Loja Exemplo Premium', 'Agro Forte')
        .replace('42', '118')
        .replace('ana@lojaexemplo.com.br', 'joao@agroforte.com.br'),
    })),
    staffUsers: [
      { name: 'João Almeida', email: 'joao@agroforte.com.br', role: 'Owner',   isOwner: true,  status: 'ativo', lastAccess: 'Hoje, 08:00', mfa: false },
      { name: 'Ana Borges',   email: 'ana@agroforte.com.br',  role: 'Gerente', isOwner: false, status: 'ativo', lastAccess: 'Ontem',       mfa: false },
    ],
    roles: [
      { name: 'Owner',   permissions: 142, users: 1, syncStatus: 'ok' },
      { name: 'Gerente', permissions: 47,  users: 1, syncStatus: 'ok' },
    ],
    domains: {
      primary: { url: md('agro-forte'), ssl: true, siteId: 4, siteName: 'Agro Forte' },
      custom: null,
      activeTheme: 'Vitrini Clean', themeVersion: '2.4.1',
      availableThemes: ['Vitrini Clean', 'Mercado Dark'],
    },
    auditLog: [
      { ts: '18 Mai, 2026', actor: 'Sistema', orgRole: '—', action: 'Tenant criado — trial iniciado', resource: 'Tenant', result: 'success', ip: '—', severity: 'info', motivo: 'Cadastro' },
    ],
  },

  // ── Outlet Max — suspenso ─────────────────────────────────────────────────
  'stor_0124': {
    staffCount: 4, storageUsed: 1.2, storageLimit: 10, healthScore: 65,
    billingStatus: 'unpaid',
    healthChecks: COCKPIT_HEALTH_CHECKS.map(c => ({
      ...c,
      status: c.id === 'public-tokens' ? 'ok'
            : c.id === 'search-index'  ? 'warning'
            : c.id === 'custom-domain' ? 'ok'
            : c.status,
      desc: c.id === 'search-index' ? 'Índice desatualizado há 27 dias (loja suspensa)'
          : c.id === 'public-tokens' ? 'Token ativo — rotação recomendada'
          : c.desc.replace('loja_exemplo_premium', 'outlet_max').replace('Loja Exemplo Premium', 'Outlet Max'),
      repairAction: c.id === 'search-index' ? null : c.repairAction,
    })),
    alerts: [
      { id: 'suspended', severity: 'danger', title: 'Tenant suspenso por inadimplência', desc: 'Suspenso em 01/05/2026 após 30 dias em atraso. Valor em aberto: R$ 499,00.', action: 'Ver billing', tab: 'actions' },
      { id: 'search',    severity: 'warning', title: 'Busca desatualizada há 27 dias', desc: 'Loja suspensa — reindexação aguarda reativação.', action: 'Ver saúde', tab: 'health' },
    ],
    provisioningSteps: PROVISIONING_STEPS.map(s => ({
      ...s,
      ts: s.ts.replace('02/11/2025', '01/06/2025'),
      msg: s.msg
        .replace('loja_exemplo_premium', 'outlet_max')
        .replace('Loja Exemplo Premium', 'Outlet Max')
        .replace('42', '124')
        .replace('ana@lojaexemplo.com.br', 'renata@outletmax.com.br'),
    })),
    staffUsers: [
      { name: 'Renata Lima',    email: 'renata@outletmax.com.br',  role: 'Owner',   isOwner: true,  status: 'ativo',   lastAccess: '20 Abr', mfa: false },
      { name: 'Marcos Duarte',  email: 'marcos@outletmax.com.br',  role: 'Gerente', isOwner: false, status: 'ativo',   lastAccess: '18 Abr', mfa: false },
      { name: 'Cristiane Alves',email: 'cris@outletmax.com.br',    role: 'Vendas',  isOwner: false, status: 'inativo', lastAccess: 'Há 2 meses', mfa: false },
      { name: 'Paulo Ramos',    email: 'paulo@outletmax.com.br',   role: 'Estoque', isOwner: false, status: 'inativo', lastAccess: 'Há 2 meses', mfa: false },
    ],
    roles: [
      { name: 'Owner',   permissions: 142, users: 1, syncStatus: 'ok' },
      { name: 'Gerente', permissions: 47,  users: 1, syncStatus: 'ok' },
      { name: 'Vendas',  permissions: 12,  users: 1, syncStatus: 'ok' },
      { name: 'Estoque', permissions: 18,  users: 1, syncStatus: 'ok' },
    ],
    domains: {
      primary: { url: md('outlet-max'), ssl: true, siteId: 5, siteName: 'Outlet Max' },
      custom: null,
      activeTheme: 'Boutique Elegance', themeVersion: '1.1.0',
      availableThemes: ['Boutique Elegance', 'Vitrini Clean'],
    },
    auditLog: [
      { ts: '01 Mai, 2026', actor: 'billing_system', orgRole: '—', action: 'Tenant suspenso por inadimplência', resource: 'Tenant', result: 'success', ip: '—', severity: 'danger', motivo: 'Automático D+30' },
      { ts: '08 Abr, 2026', actor: 'billing_system', orgRole: '—', action: 'Marcado inadimplente', resource: 'Assinatura', result: 'success', ip: '—', severity: 'warning', motivo: 'Automático D+7' },
    ],
  },
};

// ── getCockpitDataForStore ─────────────────────────────────────────────────────
// Mescla os dados do store + overrides por tenant. Atualiza globals para
// sub-componentes (cockpit-health, cockpit-actions, etc.) que lêem do window.
function getCockpitDataForStore(store) {
  if (!store) {
    return {
      tenant: COCKPIT_TENANT,
      healthChecks: COCKPIT_HEALTH_CHECKS,
      alerts: COCKPIT_ALERTS || [],
      provisioningSteps: PROVISIONING_STEPS,
      staffUsers: COCKPIT_STAFF_USERS,
      roles: COCKPIT_ROLES,
      domains: COCKPIT_DOMAINS,
      auditLog: COCKPIT_AUDIT_LOG,
    };
  }

  const override = COCKPIT_OVERRIDES[store.id] || {};
  const ns = (typeof normStatus !== 'undefined') ? normStatus(store.status) : store.status;

  const tenantData = {
    id:          store.tenant_id || store.id,
    tenantId:    store.id,
    schemaName:  store.schema_name
                   || (store.domain || '').split('.')[0].replace(/-/g, '_')
                   || store.id,
    name:        store.name,
    plan:        store.plan,
    status:      ns,
    domain:      store.domain,
    customDomain:store.customDomain || store.custom_domain || null,
    ownerName:   store.ownerName || (store.owner && store.owner.name) || '—',
    ownerEmail:  store.ownerEmail || (store.owner && store.owner.email) || '—',
    ownerPhone:  store.ownerPhone || '—',
    staffCount:  store.staff_count || override.staffCount || 1,
    createdAt:   store.createdAt || new Date(),
    healthScore: store.health_score || override.healthScore || 50,
    billingStatus: store.billing_status || override.billingStatus || 'unknown',
    storageUsed: override.storageUsed !== undefined ? override.storageUsed : 0.5,
    storageLimit: override.storageLimit || 10,
    color:       store.color || '#1B3D60',
    trial_ends_at:      store.trial_ends_at || null,
    suspended_at:       store.suspended_at || null,
    suspension_reason:  store.suspension_reason || null,
  };

  return {
    tenant: tenantData,
    healthChecks: override.healthChecks || COCKPIT_HEALTH_CHECKS,
    alerts: override.alerts || [],
    provisioningSteps: override.provisioningSteps || PROVISIONING_STEPS,
    staffUsers: override.staffUsers || COCKPIT_STAFF_USERS,
    roles: override.roles || COCKPIT_ROLES,
    domains: override.domains || COCKPIT_DOMAINS,
    auditLog: override.auditLog || COCKPIT_AUDIT_LOG,
  };
}

export {
  COCKPIT_ALERTS,
  COCKPIT_AUDIT_LOG,
  COCKPIT_DOMAINS,
  COCKPIT_HEALTH_CHECKS,
  COCKPIT_OVERRIDES,
  COCKPIT_ROLES,
  COCKPIT_STAFF_USERS,
  COCKPIT_TENANT,
  PROVISIONING_STEPS,
  getCockpitDataForStore,
};
